export const eng = {
    global: {
        next: "Next",
        name: "Name",
        email: "Email",
        emailEtc: "name@example.com"
    },
    setupWizard: {
        stepOne: {
            title: "Welcome",
            hi: "Hi",
            header: "Welcome to Happily!",
            contentOne: "You’re awesome for initiating positive experiences in your workplace. With Happily, you’re enabling better feedback, recognition, learning, community and so much more!",
            contentTwo: "To get started, we need to get your team set up, select rewards, and send out invites. Let’s begin!",
            primaryLocation: "Primary Location",
        },
        stepTwo: {
            title: "Create Team",
            header: "Create Your Team",
            contentOne: "Happily works in teams and managers are at the center. Feedback, Insights, and Reports are sent to team managers on each workday to help them better understand their team in real-time. Help us set up your team.",
            teamName: "Team Name",
            teamNameEtc: "ACME Inc",
            managersNameEt: "Manager’s Name",
            email: "Email",
            memberName: "Member Name",
        },
        stepThree: {
            title: "Select Rewards",
            contentOne: "Your team can use coins and gems collected from answering daily questions (and other interactions) to redeem rewards! Select your rewards below. You can add custom rewards later on as well.",
            SelectOneTitle: "Company Perks",
            SelectOneContentOne: "Let your team redeem Early Release (leaving work early), Half-day Fridays, and Days Off and more!",
            SelectTwoTitle: "Gift Cards",
            SelectTwoContentOne: "Let your team redeem Gift Cards from local vendors and online stores.",
            SelectTwoContentTwo: "Buy credits to enable gift cards, no extra charges applied.",
        },
        stepFour: {
            title: "Confirm & Invite",
            contentOne: "We’re almost done! Set a time you’d like your teams to receive their daily pulse questions. We recommend selecting the time when your team is commuting to work.",
            quickSettings: "QUICK SETTINGS",
            dailyPulse: "Daily Pulse",
            whatHappensNext: "WHAT HAPPENS NEXT",
            contentOneWhatHappensNext: "Invitations will be sent out to your team and everyone will receive their first set of daily pulse questions on the next workday.",
            contentTwoWhatHappensNext: "Explore your admin console to add members, view insights, create custom questions & rewards, or edit your account settings.",
        },
    },
    weMonthlyInsights: {
        yourMonthlyInsights: "Your Monthly Insights",
        howTOUse: "HOW TO USE THIS REPORT",
        thisReportIs: "This report is generated based on the interactions that we facilitate in the Happily app. The purpose of this information is to help you develop a better understanding of yourself and of your team. The best outcome are conversations that build trust, reinforce strengths, and help overcome challenges.",
        monthly: {
            yourMonthlyInsights: "Your Monthly Insights for",
            createdfor: "Created for",
            hereIsYour: "Here is your engagement report for",
            weRecommendThatboss: " We recommend that you share insights with your team that will initiate productive conversation and continuous improvement. Good luck!",
            weRecommendThat: " We recommend that you use this as a guide to initiate productive conversations with your manager towards continuous improvement. Good luck!",
            yourContributions: "Your contributions",
            dailyAttendance: "Daily Attendance",
            feedbackShared: "Feedback Shared",
            recognitionGiven: "Recognition Given",
            peerFeedback: "Peer Feedback",
            managerReplyRate: "Manager Reply Rate",
            insightsOpened: "Insights Opened",
            y_you: "YOU",
            y_youTeam: "YOUR TEAM",
            howHaveWe: "How have we been feeling over the past month?",
            m_day: "M",
            t_day: "T",
            w_day: "W",
            th_day: "Th",
            f_day: "F",
            s_day: "S",
            su_day: "Su",
            yourTeam: "YOUR TEAM",
            overallYourTeam: "Overall, your team had",
            overallYourHad: "Overall, you had",
            good: "good,",
            justOkay: "just okay,",
            and: "and",
            criticalDays: "critical days.",
            remidner: "REMINDER",
            yourPrimaryRole: "Your primary role as a people manager isn’t making everybody happy every day. It is to make sure your team bounces back quickly from setbacks and to understand & develop your talent and help resolve team challenges.",
            howAreWe: "How are we performing on different dimensions?",
            keyAreasOf: "Key areas of strengths and challenges for you to reflect with your manager",
            keyAreasOfฺBoss: "Key areas of strengths and challenges to bring to focus with your direct reports",
            focusOnGetting: "Focus on getting to know yourself better. There will always be ups and downs. Do not shy away from reaching out for help when needed.",
            andYouHave: "And you have the power to make someone’s day better. ",
            howconsist: "How consistent have you been?",
            consistencycontributions: "You’ve contributed at a ",
            consistency: "consistency.",
            month_1: "Jan",
            month_2: "Feb",
            month_3: "Mar",
            month_4: "Apr",
            month_5: "May",
            month_6: "Jun",
            month_7: "Jul",
            month_8: "Aug",
            month_9: "Sep",
            month_10: "Oct",
            month_11: "Nov",
            month_12: "Dec",
        },
        strengths: {
            whatAreOur: "What are our strengths as a team and as a company?",
            keyAreasOf: "Key areas of strengths 💪 and challenges ⚠️ to bring to focus with your team",
        },
        engaged: {
            howEngagedAre: "How engaged are we at the moment?",
            progressBasedOn: "Based on behaviors around feedback, recognition, and self-improvement",
            previousMonth: "Previous month",
            _engaged: "Engaged",
            _super: "Super",
            _highly: "Highly",
            _moderately: "Engaged",
            _somewhat: "Somewhat",
            _not: "Under",
            inActive: "In-Active",
            youHave: "You have",
            superEngaged: "Super Engaged",
            highlyEngaged: "Highly Engaged",
            moderatelyEngaged: "Engaged",
            somewhatEngaged: "Somewhat Engaged",
            notEngaged: "Not Engaged",
            underEngaged: "Under Engaged",
            youAre: "You are",
            hereIsAn: " Here is an overview of your key engagement areas & challenges:",
            membersOnYour: "members on your team. Unlock critical areas to boost engagement.",
            dailyCheckIns: "Daily Check-ins",
            peerFeedback: "Peer Feedback",
            _feedback: "Feedback",
            happilyVillage: "Happily Village",
            superFeedback: "Super Feedback",
            rewards: "Rewards",
            recognition: "Recognition",
            favoritedSparks: "Favorited Sparks",
            superRecognition: "Super Recognition",
            networkBuilding: "Network Building",
            youIndicatedThat: "You indicated that",
            isNoLonger: "is no longer on the team. How can we help?",
            cancel: "Cancel",
            notifyAdmins: "Notify Admins",
        },
        connections: {
            howAreWe: "How are we building our connections?",
            basedOnRecognition: "Based on recognition, peer feedback, and gift interactions",
            youHaveA: "You have a total of",
            connections: "connections",
            innerNetwork: "Inner network",
            newConnectionsThis: "new connections this month",
            outerNetwork: "Outer network",
            buildingRelationshipsIs: "Building relationships is a critical part of our workplace. Strong inner networks foster collaboration. Strong outer networks help us gather new information, ideas, and problem solve.",
        },
        growing: {
            howAreWe: "How are we growing and developing?",
            progressBasedOn: "Your progress based on manager & peer recognition and peer feedback",
            youAreHere: "You are here",
            youWereHere: "You were here",
            progressBasedOnBoss: "You and your team’s progress based on manager & peer recognition and peer feedback",
            individualPerformance: "Individual Performance (Manager)",
            networkEffectiveness: "Network Effectiveness (Peers)",
            s_starPerformer: "STAR PERFORMER",
            trulyOutstanding: "Truly Outstanding",
            yourDirectReports: "Your Direct Reports",
            showMore: "Load more ",
            didNotParticipate: "Did not participate in or receive Peer Feedback this month",            
            Impact_Rating: "Impact Rating",
            Network_Type: "Network Type",
            Achievements: "Achievements",
            POOR: "POOR",
            LOW:"LOW",
            OKAY: "OKAY",
            GREAT: "GREAT",
            EXCELLENT: "EXCELLENT",
            A_score_that_represents: "A score that represents an idnviduals impact on the organization and the people around them, determined by:",
            Based_on_manager_and: "Based on manager and peer recognition in the past 6-months.",
            Truly_Outstanding_ratings_from: "Truly Outstanding ratings from Peer Feedback received in the past 6-months.",
            Number_of_weeks_qualified: "Number of weeks qualified as a Star Performer in the past 6-months.",
            Medals_received_in_the: "Medals received in the past 6-months.",
            Based_on_connections_created: "Based on connections created through peer feedback, recognition, and gifting interactions in the past 6-months.",
            Based_on_the_quality_and: "Based on the quality and effort of key engagement behaviors last month.",
        }
    },
    weQuarterlyInsights: {
        yourQuarterlyInsights: "Your Quarterly Insights",
        howTOUse: "HOW TO USE THIS REPORT",
        thisReportIs: "This report is generated based on the interactions that we facilitate in the Happily app. The purpose of this information is to help you develop a better understanding of yourself and of your team. The best outcome are conversations that build trust, reinforce strengths, and help overcome challenges.",
        quarterly: {
            yourQuarterlyInsights: "Your Quarterly Insights for",
            createdfor: "Created for",
            hereIsYour: "Here is your engagement report for",
            weRecommendThatboss: " We recommend that you share insights with your team that will initiate productive conversation and continuous improvement. Good luck!",
            weRecommendThat: " We recommend that you use this as a guide to initiate productive conversations with your manager towards continuous improvement. Good luck!",
            yourContributions: "Your contributions",
            dailyAttendance: "Daily Attendance",
            feedbackShared: "Feedback Shared",
            recognitionGiven: "Recognition Given",
            peerFeedback: "Peer Feedback",
            managerReplyRate: "Manager Reply Rate",
            insightsOpened: "Insights Opened",
            y_you: "YOU",
            y_youTeam: "YOUR TEAM",
            howHaveWe: "How have we been feeling over the past quarter?",
            m_day: "M",
            t_day: "T",
            w_day: "W",
            th_day: "Th",
            f_day: "F",
            s_day: "S",
            su_day: "Su",
            yourTeam: "YOUR TEAM",
            overallYourTeam: "Overall, your team had",
            overallYourHad: "Overall, you had",
            good: "good,",
            justOkay: "just okay,",
            and: "and",
            criticalDays: "critical days.",
            remidner: "REMINDER",
            yourPrimaryRole: "Your primary role as a people manager isn't making everybody happy every day. It is to make sure your team bounces back quickly from setbacks and to understand & develop your talent and help resolve team challenges.",
            howAreWe: "How are we performing on different dimensions?",
            keyAreasOf: "Key areas of strengths and challenges for you to reflect with your manager",
            keyAreasOfฺBoss: "Key areas of strengths and challenges to bring to focus with your direct reports",
            focusOnGetting: "Focus on getting to know yourself better. There will always be ups and downs. Do not shy away from reaching out for help when needed.",
            andYouHave: "And you have the power to make someone's day better. ",
            howconsist: "How consistent have you been?",
            consistencycontributions: "You've contributed at a ",
            consistency: "consistency.",
            month_1: "Jan",
            month_2: "Feb",
            month_3: "Mar",
            month_4: "Apr",
            month_5: "May",
            month_6: "Jun",
            month_7: "Jul",
            month_8: "Aug",
            month_9: "Sep",
            month_10: "Oct",
            month_11: "Nov",
            month_12: "Dec",
        },
        strengths: {
            whatAreOur: "Key Strengths & Focus Areas This Quarter",
            keyAreasOf: "Areas that have shown consistent strength and those needing attention across the quarter",
        },
        engaged: {
            howEngagedAre: "How engaged are we at the moment?",
            progressBasedOn: "Based on behaviors around feedback, recognition, and self-improvement",
            previousMonth: "Previous quarter",
            _engaged: "Engaged",
            _super: "Super",
            _highly: "Highly",
            _moderately: "Engaged",
            _somewhat: "Somewhat",
            _not: "Under",
            inActive: "In-Active",
            youHave: "You have",
            superEngaged: "Super Engaged",
            highlyEngaged: "Highly Engaged",
            moderatelyEngaged: "Engaged",
            somewhatEngaged: "Somewhat Engaged",
            notEngaged: "Not Engaged",
            underEngaged: "Under Engaged",
            youAre: "You are",
            hereIsAn: " Here is an overview of your key engagement areas & challenges:",
            membersOnYour: "members on your team. Unlock critical areas to boost engagement.",
            dailyCheckIns: "Daily Check-ins",
            peerFeedback: "Peer Feedback",
            _feedback: "Feedback",
            happilyVillage: "Happily Village",
            superFeedback: "Super Feedback",
            rewards: "Rewards",
            recognition: "Recognition",
            favoritedSparks: "Favorited Sparks",
            superRecognition: "Super Recognition",
            networkBuilding: "Network Building",
            youIndicatedThat: "You indicated that",
            isNoLonger: "is no longer on the team. How can we help?",
            cancel: "Cancel",
            notifyAdmins: "Notify Admins",
        },
        connections: {
            howAreWe: "How are we building our connections?",
            basedOnRecognition: "Based on recognition, peer feedback, and gift interactions",
            youHaveA: "You have a total of",
            connections: "connections",
            innerNetwork: "Inner network",
            newConnectionsThis: "new connections this quarter",
            outerNetwork: "Outer network",
            buildingRelationshipsIs: "Building relationships is a critical part of our workplace. Strong inner networks foster collaboration. Strong outer networks help us gather new information, ideas, and problem solve.",
        },
        growing: {
            howAreWe: "How are we growing and developing?",
            progressBasedOn: "Your progress based on manager & peer recognition and peer feedback",
            youAreHere: "You are here",
            youWereHere: "You were here",
            progressBasedOnBoss: "You and your team's progress based on manager & peer recognition and peer feedback",
            individualPerformance: "Individual Performance (Manager)",
            networkEffectiveness: "Network Effectiveness (Peers)",
            s_starPerformer: "STAR PERFORMER",
            trulyOutstanding: "Truly Outstanding",
            yourDirectReports: "Your Direct Reports",
            showMore: "Load more ",
            showLess: "Show less",
            didNotParticipate: "Did not participate in or receive Peer Feedback this quarter",
            Impact_Rating: "Impact Rating",
            Network_Type: "Network Type",
            Achievements: "Achievements",
            POOR: "POOR",
            LOW:"LOW",
            OKAY: "OKAY",
            GREAT: "GREAT",
            EXCELLENT: "EXCELLENT",
            A_score_that_represents: "A score that represents an idnviduals impact on the organization and the people around them, determined by:",
            Based_on_manager_and: "Based on manager and peer recognition in the past 6-months.",
            Truly_Outstanding_ratings_from: "Truly Outstanding ratings from Peer Feedback received in the past 6-months.",
            Number_of_weeks_qualified: "Number of weeks qualified as a Star Performer in the past 6-months.",
            Medals_received_in_the: "Medals received in the past 6-months.",
            Based_on_connections_created: "Based on connections created through peer feedback, recognition, and gifting interactions in the past 6-months.",
            Based_on_the_quality_and: "Based on the quality and effort of key engagement behaviors last quarter.",

            // New talent dashboard translations
            promotionReady: "Promotion Ready",
            developmentNeeded: "Development Needed",
            hiddenGems: "Hidden Gems",
            atRisk: "At Risk",

            promotionTrack: "Promotion Track",
            promotionTrackDesc: "High performers who are ready for advancement based on their impact rating, talent level, and engagement.",
            promotionRecommendation: "Ready for promotion review and career advancement discussion.",

            developmentTrack: "Development Track",
            developmentTrackDesc: "Team members who need additional support, coaching, or development to improve performance.",
            developmentRecommendation: "Schedule 1-on-1 to discuss development plan and support needs.",

            hiddenGemsTrack: "Hidden Gems to Spotlight",
            hiddenGemsDesc: "Strong performers with low visibility who should be given opportunities to increase their impact and network.",
            hiddenGemsRecommendation: "Create opportunities to increase visibility through cross-team projects, presentations, or mentorship.",

            atRiskTrack: "At-Risk High Performers",
            atRiskDesc: "Talented individuals showing signs of declining engagement or performance - retention concern.",
            atRiskRecommendation: "Immediate check-in required to understand concerns and prevent turnover.",

            engagementConcern: "Engagement Concern",
            retentionRisk: "Retention Risk - Declining Performance",
            inactive: "Inactive",
            underEngaged: "Under Engaged",

            // Track labels for individual user card
            performanceTrack: "Performance Track",
            hiddenGem: "Hidden Gem",
            needsDevelopment: "Needs Development",
            onTrack: "On Track",
        }
    },
    questionDetail: {
        QUESTION_DETAILS: "QUESTION DETAILS",
        Scale: "Scale",
        Multiple_Choice: "Multiple Choice",
        Yes_No: "Yes/No",
        average: "average",
        out_of_10: "out of 10",
        responses: "responses",
        response: "response",
        score: "score",
    },
};